import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PickupSessionGroupCreateEditForm from './Components/PickupSessionGroupCreateEditForm';
import PickupSessionGroupApi from './PickupSessionGroupApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PickupSessionGroupCreateEditForm,
                getCreate: PickupSessionGroupApi.create,
                defaults: {},
                successMessage: "Pickup Session Group Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}